import React, { Component } from 'react';
import logo from '../img/shortLogo.png';

class LoadingPage extends Component {
  render() {
    const styles = {
      loadingPage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5', 
      },
      spinner: {
        width: '100px',
        height: '100px',
        border: '5px solid rgba(0, 0, 0, 0.1)',
        borderTop: '5px solid #3498db', 
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      spinnerLogo: {
        width: '70px', 
        height: '70px',
      },
      '@keyframes spin': {
        '0%': {
          transform: 'rotate(0deg)',
        },
        '100%': {
          transform: 'rotate(360deg)',
        },
      },
    };

    return (
      <div style={styles.loadingPage}>
        <div style={styles.spinner}>
            <img src={logo} alt="Logo" style={styles.spinnerLogo} />
        </div>
        <style>{`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}</style>
      </div>
    );
  }
}

export default LoadingPage;
